import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend, Label
} from "reactstrap"
import { accessRole } from '../../../../helpers/access_role'
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import CustomSelect from '../../../../helpers/ui/CustomSelect'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'

import { cancelToken } from "../../../../services/adapters/kepegawaian/penataranService"
import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar'
import CreateBloc from './Blocs/CreateBloc'
import IndexBloc from '../Index/Blocs/IndexBloc'

let peg_uuid = JSON.parse(localStorage.getItem('userdata')) != null ? JSON.parse(localStorage.getItem('userdata')).employee_uuid : "";
if(accessRole('approve')){
    peg_uuid = JSON.parse(localStorage.getItem('employeeSelected')) != null ? JSON.parse(localStorage.getItem('employeeSelected')).employee_uuid : "";
}


class CreateView extends Component {

    createBloc = new CreateBloc()
    indexBloc = new IndexBloc()
    source
    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            domicile: 0,
            regionOption: [],
            provinceOption: [],
            cityOption: [],
        }
    }

    submitData = async () => {
        const formData = generateFormData(this.state.dataForm, 'document') // 'document' disini adalah nama field FileInput. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto'] 
        await this.createBloc.fetchCreate(formData)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              employee_uuid : peg_uuid,
              ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    getCity = (province_uuid) => {
        this.indexBloc.regionCityChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ cityOption: result.data.response.result })
                    break;
                default:
                    break;
            }
        })
        const query = { 
            is_local: 1,
            type : 3,
            parent_uuid : province_uuid
        }
        this.indexBloc.fetchRegionCity(query, this.source.token)
    }

    loadProvince = async () => {
        const query = { 
            parent_uuid: '61b47307-167d-489f-bb6c-c1c9662acab3',
            type: 2
        }
        await this.indexBloc.fetchRegionProvince(query, this.source.token)
    }

    loadRegion = async () => {
        const query = { type: 1 }
        await this.indexBloc.fetchRegion(query, this.source.token)
    }


    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadRegion()
        this.loadProvince()
    }

    componentDidMount() {
        this.setTokenAPI()

        this.indexBloc.regionProvinceChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ provinceOption: result.data.response.result })
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.regionChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ regionOption: result.data.response.result })
                    break;
                default:
                    break;
            }
        })

        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

    }

    componentWillUnmount() {
        this.createBloc.createChannel?.unsubscribe()
        this.indexBloc.regionChannel?.unsubscribe()
        this.indexBloc.regionCityChannel?.unsubscribe()
        this.indexBloc.regionProvinceChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <PegawaiSideBar active="penataran"/>

                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <CardTitle>Tambah Penataran</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldNama"
                                                className="col-md-2 col-form-label"
                                            >
                                                Nama Penataran <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="6">
                                                <AvField
                                                    name="upgrading_skill_name"
                                                    placeholder="Nama Penataran"
                                                    errorMessage="Masukkan Nama Penataran"
                                                    type="text"
                                                    className="form-control"
                                                    id="fieldNama"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <hr/>
                                        <Label># Tempat Penataran</Label>
                                        <Row className="mb-3">
                                            <Label className="col-md-2 col-form-label">Dalam / Luar Negeri<span className="text-danger">*</span></Label>
                                             <Col md="3">
                                                <CustomSelect 
                                                    name="upgrading_skill_domicile"
                                                    errorMessage="Pilih Domisili"
                                                    options={[{ value: 0, label: 'Dalam Negeri' }, { value: 1, label: 'Luar Negeri' }]}
                                                    defaultValue={this.state.domicile}
                                                    onChange={opt => this.setState({ domicile: opt.value })}
                                                    placeholder="Pilih Domisili"
                                                    validate={{ required: { value: true } }}
                                                    isSearchable={false}
                                                />
                                            </Col>                                           
                                        </Row>
                                        { this.state.domicile == 0 ?
                                            <Fragment>
                                                <AvField 
                                                    type="hidden" 
                                                    name="upgrading_skill_country_uuid" 
                                                    value={this.state.regionOption?.filter(value => value.region_name == 'Indonesia')[0]?.region_uuid} 
                                                />
                                                <Row className="mb-3">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                    Provinsi <span className="text-danger">*</span>
                                                    </Label>
                                                    <Col md="3">
                                                        <CustomSelect 
                                                            name="upgrading_skill_province_uuid"
                                                            errorMessage="Pilih Provinsi"
                                                            // onChange={this.handleIdentitySelectProvince}
                                                            onChange={value => this.getCity(value.region_uuid)}
                                                            options={this.state.provinceOption}
                                                            optionLabel="region_name"
                                                            optionValue="region_uuid" 
                                                            validate={{ required: { value: true } }}
                                                            placeholder="Pilih Provinsi"
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                        Kota <span className="text-danger">*</span>
                                                    </Label>
                                                    <Col md="3">
                                                        <CustomSelect 
                                                            name="upgrading_skill_city_uuid"
                                                            errorMessage="Pilih Kota Lahir"
                                                            options={this.state.cityOption} 
                                                            optionLabel="region_name"
                                                            optionValue="region_uuid"
                                                            validate={{ required: { value: true } }}
                                                            placeholder="Pilih Kota Lahir"
                                                        />
                                                    </Col>
                                                </Row>
                                            </Fragment>
                                            :
                                            <Fragment>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">Negara <span className="text-danger">*</span></Label>
                                                    <Col md="3">
                                                        <CustomSelect 
                                                            name="upgrading_skill_country_uuid"
                                                            errorMessage="Pilih Negara"
                                                            options={this.state.regionOption}
                                                            optionValue="region_uuid"
                                                            optionLabel="region_name"
                                                            placeholder="Pilih Negara"
                                                            validate={{ required: { value: true } }}
                                                        />
                                                    </Col>                                           
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                    Kota <span className="text-danger">*</span>
                                                    </Label>
                                                    <Col md="3">
                                                        <AvField
                                                            name="upgrading_skill_city_text"
                                                            placeholder="Kota..."
                                                            type="text"
                                                            errorMessage="Masukkan Kota"
                                                            className="form-control"
                                                            validate={{ required: { value: this.state.isLocal == 1 ? false : true } }}
                                                            id="place_of_birth_city_text"
                                                        />
                                                    </Col>
                                                </Row>
                                            </Fragment> 
                                        }
                                        <hr/>
                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldPenyelenggara"
                                                className="col-md-2 col-form-label"
                                            >
                                                Penyelanggara <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="6">
                                                <AvField
                                                    name="upgrading_skill_organizer"
                                                    placeholder="Nama Penyelanggara"
                                                    errorMessage="Masukkan Penyelanggara"
                                                    type="text"
                                                    className="form-control"
                                                    id="fieldPenyelenggara"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>


                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldTglMulai"
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Mulai <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="2">
                                                <AvField
                                                    name="upgrading_skill_start_date"
                                                    placeholder="Tanggal Mulai"
                                                    errorMessage="Masukkan Tanggal Mulai"
                                                    type="date"
                                                    className="form-control"
                                                    id="fieldTglMulai"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldTglSelesai"
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Selesai <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="2">
                                                <AvField
                                                    name="upgrading_skill_end_date"
                                                    placeholder="Tanggal Selesai"
                                                    errorMessage="Masukkan Tanggal Selesai"
                                                    type="date"
                                                    className="form-control"
                                                    id="fieldTglSelesai"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldNoPiagam"
                                                className="col-md-2 col-form-label"
                                            >
                                                No Piagam <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="4">
                                                <AvField
                                                    name="upgrading_skill_charter_number"
                                                    placeholder="No Piagam"
                                                    errorMessage="Masukkan No Piagam"
                                                    type="text"
                                                    className="form-control"
                                                    id="fieldNoPiagam"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldTglPiagam"
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Piagam <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="2">
                                                <AvField
                                                    name="upgrading_skill_charter_date"
                                                    placeholder="Tanggal Piagam"
                                                    errorMessage="Masukkan Tanggal Piagam"
                                                    type="date"
                                                    className="form-control"
                                                    id="fieldTglPiagam"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldTglPiagam"
                                                className="col-md-2 col-form-label"
                                            >
                                                File Piagam 
                                            </Label>
                                            <Col md="6">
                                                <FileInput 
                                                    name="document"
                                                    isMultiple
                                                />
                                            </Col>
                                        </Row>

                                       <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/kepegawaian/home.html?penataran">
                                                    <Button color="success" type="button"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>

                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/home.html?penataran'/>
                : null }
            </Fragment>
        )
    }

}

export default CreateView